import { render } from "./Memorial.vue?vue&type=template&id=efff3e6e&scoped=true"
import script from "./Memorial.vue?vue&type=script&lang=js"
export * from "./Memorial.vue?vue&type=script&lang=js"

import "./Memorial.vue?vue&type=style&index=0&id=efff3e6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efff3e6e"]])

export default __exports__